import Link from "next/link";

export default function Email({
  text = process.env.NEXT_PUBLIC_EMAIL,
  className,
  ...props
}) {
  return (
    <Link
      href={`mailto:${
        process.env.NEXT_PUBLIC_EMAIL
      }?subject=Website%20Enquiry%20-%20${
        process.env.NEXT_PUBLIC_URL || process.env.NEXT_PUBLIC_VERCEL_URL
      }&body=Hey%20there!`}
    >
      <a className={`underline ${className || ""}`}>{text}</a>
    </Link>
  );
}
